<template>
  <section class="reasons-invest">
      <div class="reasons-invest__content container">
        <div class="reasons-invest__text">
          <h3 class="reasons-invest__subtitle --fade-in-right" data-vertical-ivp-class="--animate">Item 9 Labs Corp.</h3>
          <h1 class="reasons-invest__title">Reasons to Invest</h1>
          <p class="reasons-invest__description">
            Item 9 Labs Corp. has launched a global, streamlined public offering
            for unaccredited and accredited investors.
            <br/><br/>
            Now anyone can become a shareholder in Item 9 Labs Corp.,
            which includes the national dispensary franchise Unity Rd. and
            leading cannabis brand Item 9 Labs.
          </p>
          <ul class="reasons-invest__list">
            <li>
              Item 9 Labs has 24 podium awards and is available in leading
              dispensaries (LeafLink, 2022).
            </li>
            <li>
              Unity Rd. is the first national cannabis dispensary franchise in the U.S.,
              with more than 20 partners developing the brand across 9 states.
            </li>
            <li>
              Unity Rd. is the first plant-touching cannabis concept to become a
              member of the International Franchise Association (IFA).
            </li>
            <li>Item 9 Labs currently has 20,000 square feet of operations.</li>
          </ul>
          <a  class="button-outlined --text-dark"
              href="https://item9labs.app..tech/invitations/keep-cannabis-local/view"
              target="_blank">
            <div class="text">Start Investing</div>
            <div class="line -right"></div>
            <div class="line -top"></div>
            <div class="line -left"></div>
            <div class="line -bottom"></div>
          </a>
        </div>
        <div class="reasons-invest__image">
          <div class="image">
            <div class="quote --fade-in-up" data-ivp-class="--animate">
              <h1>Motivated by quality, driven with community.</h1>
            </div>
          </div>
        </div>
      </div>
      
  </section>
</template>

<script>
export default {
  name: 'ReasonsInvest',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/ReasonsInvest.scss";
</style>
